import type CSS from 'csstype';

export function colorAlpha(
  hex: string | (CSS.Property.BackgroundColor | undefined )[] | readonly string[],
  alpha: string
): string {
  let channels: string[] = ['FF', 'FF', 'FF'];

  if (typeof hex === 'string') {
    if (!hex.match(/^#/)) {
      return hex;
    }

    const letters = hex.match(/\w/g) || [];

    if (letters.length === 3) {
      channels = hex.match(/\w/g) || [];
      channels = channels.map((l: string): string => `${l}${l}`);
    } else if (letters.length === 6) {
      channels = hex.match(/\w{2}/g) || [];
    } else {
      return hex;
    }
  }

  if (Array.isArray(hex)) {
    const firstHex = hex[0];

    if (typeof firstHex !== 'undefined') {
      if (!firstHex.match(/^#/)) {
        return firstHex;
      }

      const letters = firstHex.match(/\w/g) || [];

      if (letters.length === 3) {
        channels = firstHex.match(/\w/g) || [];
        channels = channels.map((l: string): string => `${l}${l}`);
      } else if (letters.length === 6) {
        channels = firstHex.match(/\w{2}/g) || [];
      } else {
        return firstHex;
      }
    }
  }

  const [r, g, b] = channels.map((x: string): number => parseInt(x, 16));

  return `rgba(${r},${g},${b},${alpha})`;
}
